export default {
  /**
   * Routing accessibility - Once routed, call focus on the main content with focusfirst ref
   */
  mounted() {
    if (this.$refs.focusFirst) this.$refs.focusFirst.focus();
  },
};
